import { Route } from '@angular/router';
import { salonResolver } from './core/resolver/salon.resolver';
import { subdomainHomeGuard } from './core/guard/subdomain-home.guard';

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./home/home').then((m) => m.Home),
    canActivate: [subdomainHomeGuard],
  },
  {
    path: 's/:salonId',
    loadChildren: () => import('./salon/salon.routes').then((m) => m.SALON_ROUTES),
    resolve: { salon: salonResolver },
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];
